<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-content-width astral-stack-l">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          @if (meterTypeSelection) {
            <astral-select [control]="form.controls['meterType']" [itemsSource]="meterTypeSelection"></astral-select>
          }
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-input [control]="form.controls['manufacturer']"></astral-input>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
